import { string } from "prop-types";
import { useCallback } from "react";
import { useParams } from "react-router-dom";

import styled from "styled-components/macro";

import FnrTypography from "UI/FnrTypography";
import { useGiveLogout } from "Login/TwoFA/API/queries";

import FnrContainedIcon from "UI/FnrContainedIcon";
import FnrTappyShrink from "UI/FnrTappyShrink";

import externalNavigate from "Utilities/externalNavigate";

import { useLogout } from "../API/queries";
import { useMemberToobarContext } from "../MemberToolbarState";
import { contentKeys } from "../contentKeys";
import { useMemberToolbarStore } from "../memberToolbarStore";

import { ButtonWrapper } from "./shared";

const DisplayComponent = ({ color }) => {
  const { isLoggingOut, isThin } = useMemberToobarContext();
  return (
    <FnrTappyShrink>
      <FnrTypography type="copy" fontSize={isThin ? "xs" : "sm"} color={color}>
        Log&nbsp;Out
      </FnrTypography>
      <FnrContainedIcon
        color={color}
        isLoading={isLoggingOut}
        icon="fa-sign-in fas"
        size={isThin ? "sm" : "md"}
        yCorrection={isThin ? -1 : 0}
      />
    </FnrTappyShrink>
  );
};

DisplayComponent.propTypes = { color: string };

const LogoutButton = () => {
  const { setActiveContentKey } = useMemberToolbarStore();
  const {
    onAuthChange,
    setIsLoggingOut,
    logoutGoesToLogin,
    tabID,
    loginVariant,
  } = useMemberToobarContext();

  // note that the "isLoading" property here is local to this hook instance and can't be seen global. Hence, isLogginOut from context.
  const { mutateAsync } = useLogout({ invalidate: !logoutGoesToLogin });
  const { fundID } = useParams();

  const { mutateAsync: giveLogout } = useGiveLogout({
    fundID: Number(fundID),
    tabID,
  });

  const handleClick = useCallback(async () => {
    setIsLoggingOut(true); // set back to false in MemberToolbar.jsx
    if (loginVariant === "give") await giveLogout();
    else await mutateAsync();
    setActiveContentKey(contentKeys.nothing);
    if (logoutGoesToLogin) externalNavigate("/login", "_self");
    else if (onAuthChange) {
      onAuthChange(false);
    } else window.location.reload(true);
  }, [
    giveLogout,
    loginVariant,
    logoutGoesToLogin,
    mutateAsync,
    onAuthChange,
    setActiveContentKey,
    setIsLoggingOut,
  ]);

  return (
    <SButtonWrapper
      onClick={handleClick}
      data-cy="MemberToolbar_LogoutButton"
      DisplayComponent={DisplayComponent}
    />
  );
};

const SButtonWrapper = styled(ButtonWrapper)`
  display: flex;
  align-items: center;
  padding: 0 4px 0 12px;
  height: 28px;
`;

export { LogoutButton };
